var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid bulk-cate"},[_c('div',{staticClass:"page-header"},[_c('Breadcrumbs',{attrs:{"main":"Reports","title":"Reports"}})],1),_c('div',{staticClass:"row"},[_c('salesSummary'),_c('employee'),_c('transferReports'),_c('expenses'),_c('salesPurchase'),_c('salesreturn')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }